import { css } from '@/styled-system/css';

/** Icon + label row inside each Menu.Item. */
export const menuItemRow = css({
  alignItems: 'center',
  display: 'flex',
  gap: 'tighter',
});
